import { atom } from "recoil";

export const inventoryDBState = atom<any[]>({
    key: 'inventoryDBState',
    default : []
});